import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useParams } from "react-router";
import { SplitPane } from "react-collapse-pane";
import { Navbar } from "../../Components/Navbar";
import TbcHeader from "../Components/TBC/TbcHeader";
import { useDispatch, useSelector } from "react-redux";
import { getBCTbRows } from "../../redux/actions/BookClosure/actionBookClosure";
import Loader from "../../helper/loader";
import TbConventionalMode from "../Components/TBC/TbConventionalMode";
import TemplateTab from "../Components/TBC/TemplateTab";
import { motion } from "framer-motion";

import Sidebar from "../../myfin_v2/elements/Sidebar";
import commoncss from "../../myfin_v2/css/common.module.css";

const ConvetionalTbc = () => {
    const { bookClosureTbId } = useParams();
    const dispatch = useDispatch();

    const { lineItems, groupings, filters, loading, errorMessage, error } =
        useSelector((initialState) => initialState.BookClosureTbcReducer);

    useEffect(() => {
        dispatch(getBCTbRows(bookClosureTbId));
    }, [dispatch, bookClosureTbId]);


    const [allLineItems, setAllLineItems] = useState([]);
    const [filteredLineItems, setFilteredLineItems] = useState([]);

    useEffect(() => {
        if (lineItems?.length > 0) {
            setAllLineItems(lineItems);
            setFilteredLineItems(lineItems);
        }
    }, [lineItems]);

    const [searchText, setSearchText] = useState("");

    return (
        <div className={commoncss.pageLayout}>
            <Sidebar />
            <div className={`d-flex ${commoncss.pageContent}`}>
                <div
                    className={`${commoncss.w100} `}
                    style={{ maxHeight: "95vh", overflow: "hidden" }}
                >
                    <TbcHeader
                        allLineItems={allLineItems}
                        setFilteredLineItems={setFilteredLineItems}
                        lineItems={filteredLineItems}
                        currentMode="1"
                        searchText={searchText}
                        setSearchText={setSearchText}
                        splitMapping={false}
                    />
                    <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeInOut" }}>
                        <div
                            className="tabsinside w-100 px-3"
                            style={{ maxHeight: "95vh", overflow: "scroll" }}
                        >

                            <div className="h-100">
                                <div style={{ overflow: "scroll", height: "100%" }}>
                                    {loading ? (
                                        <Loader />
                                    ) : error ? (
                                        <p className="d-flex justify-content-center align-items-center h-100 text-danger">
                                            {errorMessage}
                                        </p>
                                    ) : (
                                        <TbConventionalMode
                                            bookClosureTbId={bookClosureTbId}
                                            groupings={groupings}
                                            lineItems={filteredLineItems.length > 0 ? filteredLineItems : []}
                                            searchText={searchText}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ConvetionalTbc);
